export const Jogosultsag = Object.freeze({
  /** 137 */
  Szerzo: 137,
  /** 138 */
  Szerkeszto: 138,
});
